@use '@/scss/underscore' as _;

.description {
  color: var(--color-text-secondary);
  font: var(--font-body-2);
  margin-top: _.unit(1);
}

.inlineNotification {
  margin-top: _.unit(6);
}
